import React from "react";
import { Award } from "lucide-react";
import { Button } from "./ui/button";
import { trackCTAClick } from "../utils/analytics";

export const MentorSectionCRO = ({ onEnrollClick }) => {
  return (
    <section
      id="about"
      className="py-20 px-6 lg:px-8 bg-gradient-to-b from-purple-50 to-white"
    >
      <div className="max-w-6xl mx-auto">
        {/* Section Badge */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-purple-100 border border-purple-300 rounded-full mb-4">
            <Award className="w-4 h-4 text-purple-600" />
            <span className="text-sm font-semibold text-purple-700">
              Padma Shri Awardee 2025
            </span>
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            Meet Your Mentor
          </h2>
          <p className="text-xl text-gray-600">Learn from the legend himself</p>
        </div>

        <div className="flex flex-col lg:flex-row items-center gap-12 bg-white border-2 border-purple-100 rounded-3xl p-8 md:p-12 shadow-lg">
          {/* Image */}
          <div className="flex-shrink-0">
            <div className="relative group">
              <div className="absolute -inset-1 bg-gradient-to-r from-purple-500 to-purple-600 rounded-2xl blur opacity-30 group-hover:opacity-50 transition duration-300"></div>
              <img
                src="/images/Barry-John.jpg"
                alt="Barry John"
                className="relative w-80 h-96 object-cover rounded-2xl border-4 border-purple-200 shadow-xl"
              />
            </div>
          </div>

          {/* Content */}
          <div className="flex-1 text-center lg:text-left">
            <h3 className="text-3xl font-bold text-gray-900 mb-2">
              Barry John
            </h3>
            <p className="text-lg text-purple-600 font-semibold mb-6">
              Founder & Director, The Free Birds Collective
            </p>

            <p className="text-gray-700 leading-relaxed mb-6">
              Barry John is a renowned acting teacher and theatre director with
              over{" "}
              <span className="font-semibold text-gray-900">
                50 years of experience
              </span>{" "}
              in shaping the careers of some of India's finest actors.
            </p>

            <p className="text-gray-700 leading-relaxed mb-6">
              Honored with the prestigious{" "}
              <span className="font-semibold text-gray-900">
                Padma Shri Award in 2025
              </span>
              , Barry has trained legendary actors including Shah Rukh Khan,
              Manoj Bajpayee, Rana Daggubati, Varun Dhawan, and many more.
            </p>

            <div className="bg-purple-50 border-l-4 border-purple-600 p-4 mb-8">
              <p className="text-gray-800 italic">
                "No lectures, no theories, no pseudo-intellectualism. Just pure,
                practical skill development that empowers actors to own their
                craft."
              </p>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
};
